import { APP_TERMS } from './app-terms';
import {
  dashboard,
  menuicon06,
  menuicon08,
  // menuicon09,
  menuicon13,
} from './components/imagepath';

export const AppLocales = {
  enUs: 'enUs',
};
export const DEFAULT_DEBOUNCE_INTERVAL = 500;
export const CASE_FORM_TYPES = {
  patientDetails: 'PATIENT_DETAILS',
  studyPurpose: 'STUDY_PURPOSE',
  addServices: 'ADD_SERVICES',
  uploadFiles: 'UPLOAD_FILES',
};
export const APP_USER_TYPES = {
  clinicUser: 'clinicUser',
};
export const APP_MASTER_TYPES = {
  service: 'service',
};
export const STUDY_PURPOSES = [
  { label: APP_TERMS.airway_label, fieldName: 'airwayFlag' },
  { label: APP_TERMS.generic_general, fieldName: 'generalFlag' },
  { label: APP_TERMS.impaction_label, fieldName: 'impactionFlag' },
  { label: APP_TERMS.implant_label, fieldName: 'implantFlag' },
  { label: APP_TERMS.orthodontic_label, fieldName: 'orthodonticFlag' },
  { label: APP_TERMS.pathology_label, fieldName: 'pathologyFlag' },
  { label: APP_TERMS.sinus_label, fieldName: 'sinusFlag' },
  { label: APP_TERMS.tmd_pain_label, fieldName: 'painFlag' },
];
export const SIDEBAR_ITEMS = [
  {
    to: '/user/admin-dashboard',
    id: 'dashboard',
    title: 'Dashboard',
    icon: dashboard,
  },
  {
    id: 'cases',
    title: APP_TERMS.generic_case,
    icon: menuicon13,
    to: '/user/case/created',
    children: [
      {
        id: 'casenew',
        to: '/user/case/add',
        title: 'New Case',
        activeClassName: 'case-new',
      },
      {
        id: 'casecreated',
        to: '/user/case/created',
        title: 'Pending',
        activeClassName: 'case-created',
      },
      {
        id: 'casesubmitted',
        to: '/user/case/submitted',
        title: 'Submitted',
        activeClassName: 'case-submitted',
      },
      {
        id: 'casecompleted',
        to: '/user/case/completed',
        title: 'Completed',
        activeClassName: 'case-completed',
      },
    ],
  },
  {
    id: 'users',
    title: 'Staff',
    icon: menuicon08,
    to: '/user/userslist',
    children: [
      {
        id: 'stafflist',
        to: '/user/userslist',
        title: 'List',
        activeClassName: 'user-list',
      },
    ],
  },
  {
    id: 'branches',
    title: 'Clinic Location',
    icon: menuicon06,
    to: '/user/branchlist',
    children: [
      {
        id: 'branchlist',
        to: '/user/branchlist',
        title: 'List',
        activeClassName: 'branch-List',
      },
    ],
  },
  // {
  //   id: 'revenue',
  //   title: APP_TERMS.generic_accounting,
  //   icon: menuicon09,
  //   to: '/user/invoicelist',
  //   children: [
  //     {
  //       id: 'invoicelist',
  //       to: '/user/invoicelist',
  //       title: 'Invoice List',
  //       activeClassName: 'invoice-list',
  //     },
  //     {
  //       id: 'invoice-report-list',
  //       to: '/user/invoice-report-list',
  //       title: 'Report',
  //       activeClassName: 'invoice-report-list',
  //     },
  //   ],
  // },
];

export const LOGIN_FORM_TYPES = {
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  CUSTOM_CHALLENGE: 'CUSTOM_CHALLENGE',
};
export const LOGIN_STEPS = {
  EMAIL: 'EMAIL',
  PASSWORD: 'PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD',
  OTP: 'OTP',
};
export const USER_STATUS = {
  CONFIRMED: 'CONFIRMED',
  UNCONFIRMED: 'UNCONFIRMED',
  RESET_REQUIRED: 'RESET_REQUIRED',
  FORCE_CHANGE_PASSWORD: 'FORCE_CHANGE_PASSWORD',
  DISABLED: 'DISABLED',
};
export const PaymentFor = {
  CASE: 'CASE',
  INVOICE: 'INVOICE',
};
export const InvoiceType = {
  MONTHLY: 'MONTHLY',
  PAY_AS_YOU_GO: 'PAY_AS_YOU_GO',
};
export const PRIVACY_POLICY_EXTERNAL_URL = 'https://voxelwp.eternalsoft.in/terms-and-conditions/';
export const DATE_FORMAT = "MM-DD-YYYY";